// @owners { team: patients }
import { ANIMATION } from '@alto/design-library-tokens';
import { css } from 'styled-components';

export type StyledTouchableProps = {
  disabled?: boolean;
  loading?: boolean;
};

export const StyledTouchable = css<StyledTouchableProps>`
  opacity: ${({ disabled, loading }) => (disabled || loading ? '0.75' : '1')};
  transition: all ${ANIMATION.SPEEDS.FASTER / 1000}s ease-in-out;
  user-select: none;
  &:hover {
    cursor: pointer;
  }
  &:active {
    ${({ disabled, loading }) => !disabled && !loading && 'opacity: 0.75;'};
  }
`;
